// generated by the plop

import { UserModel } from 'shared';
import { PROGRESS_STATUSES } from 'symbols';

export interface ProfileStateModel {
  currentUser: UserModel;
  loadCurrentUserStatus: PROGRESS_STATUSES;
}

export const PROFILE_STATE_DEFAULT: ProfileStateModel = {
  currentUser: null,
  loadCurrentUserStatus: PROGRESS_STATUSES.NOT_INITIALIZED
};
